import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { hideModal, hideReport } from '../../../../actions/modal';
import { clearForm } from '../../../../actions/report';

import Modal from '../../../modal';
import FormFields from '../form-fields';

const ReportModal = ({ snackbarStatus, hideModal, hideReport, clearForm, httpStatus }) => {
    const onClose = () => {
        hideModal();
        hideReport();
        if (httpStatus.loaded) {
            clearForm();
        }
    };

    return (
        <Modal title="Problemi o suggerimenti?" onClose={onClose}>
            <FormFields snackbarStatus={snackbarStatus} />
        </Modal>
    );
};

ReportModal.propTypes = {
    clearForm: PropTypes.func,
    snackbarStatus: PropTypes.string,
    hideModal: PropTypes.func,
    hideReport: PropTypes.func,
    httpStatus: PropTypes.object,
};

const actionsCreator = {
    hideModal: hideModal,
    hideReport: hideReport,
    clearForm: clearForm,
};

const mapStateToProps = (state) => {
    return {
        httpStatus: state.report.status,
    };
};
export default connect(mapStateToProps, actionsCreator)(ReportModal);
